/**
 * Promo Popup - GemKits Diamond Painting Theme
 * Handles popup display, timing, dismissal, countdown timer, and copy functionality
 */

(function() {
  'use strict';

  const STORAGE_KEY_PREFIX = 'promo-popup-dismissed-';
  const VISIT_TIME_KEY = 'promo-popup-first-visit';

  function initPromoPopup() {
    const popup = document.querySelector('[data-section-type="newsletter-popup"]');
    if (!popup) return;

    const overlay = popup.previousElementSibling;
    const testMode = popup.dataset.testMode === 'true';
    const delaySeconds = parseInt(popup.dataset.delaySeconds, 10) || 5;
    const delayDays = parseInt(popup.dataset.delayDays, 10) || 30;
    const displayTimer = popup.dataset.displayTimer === 'true';
    const timerDuration = parseFloat(popup.dataset.timerDuration) || 3;

    const storageKey = STORAGE_KEY_PREFIX + window.location.host;

    // Check if popup was dismissed recently (unless in test mode)
    if (!testMode) {
      const dismissedData = localStorage.getItem(storageKey);
      if (dismissedData) {
        try {
          const { timestamp } = JSON.parse(dismissedData);
          const daysSinceDismissed = (Date.now() - timestamp) / (1000 * 60 * 60 * 24);
          if (daysSinceDismissed < delayDays) {
            return;
          }
        } catch (e) {
          // Invalid data, continue showing popup
        }
      }
    }

    // Handle delay with persistence across page navigations
    if (testMode) {
      // Test mode: show immediately
      showPopup(popup, overlay);
      if (displayTimer) {
        startTimer(popup, timerDuration);
      }
    } else {
      // Get or set the first visit timestamp
      let firstVisitTime = sessionStorage.getItem(VISIT_TIME_KEY);

      if (!firstVisitTime) {
        // First page visit this session - store the time
        firstVisitTime = Date.now().toString();
        sessionStorage.setItem(VISIT_TIME_KEY, firstVisitTime);
      }

      const elapsedMs = Date.now() - parseInt(firstVisitTime, 10);
      const delayMs = delaySeconds * 1000;
      const remainingMs = delayMs - elapsedMs;

      if (remainingMs <= 0) {
        // Delay already passed - show popup now
        showPopup(popup, overlay);
        if (displayTimer) {
          startTimer(popup, timerDuration);
        }
      } else {
        // Wait for remaining time
        setTimeout(() => {
          showPopup(popup, overlay);
          if (displayTimer) {
            startTimer(popup, timerDuration);
          }
        }, remainingMs);
      }
    }

    // Setup close handlers
    setupCloseHandlers(popup, overlay, storageKey, testMode);

    // Setup copy button handler
    setupCopyHandler(popup);
  }

  function showPopup(popup, overlay) {
    popup.classList.add('popup-modal--active');
    if (overlay) {
      overlay.classList.add('popup-overlay--active');
    }
    document.body.style.overflow = 'hidden';

    // Clear the first visit time so it doesn't show again this session
    sessionStorage.removeItem(VISIT_TIME_KEY);
  }

  function hidePopup(popup, overlay) {
    popup.classList.remove('popup-modal--active');
    if (overlay) {
      overlay.classList.remove('popup-overlay--active');
    }
    document.body.style.overflow = '';
  }

  function setupCloseHandlers(popup, overlay, storageKey, testMode) {
    const closeBtn = popup.querySelector('.popup-modal__close');
    const dismissBtn = popup.querySelector('.popup-modal__dismiss-btn');

    function handleClose() {
      hidePopup(popup, overlay);

      // Save dismissal timestamp (unless in test mode)
      if (!testMode) {
        localStorage.setItem(storageKey, JSON.stringify({
          timestamp: Date.now()
        }));
      }
    }

    if (closeBtn) {
      closeBtn.addEventListener('click', handleClose);
    }

    if (dismissBtn) {
      dismissBtn.addEventListener('click', handleClose);
    }

    if (overlay) {
      overlay.addEventListener('click', handleClose);
    }

    // Close on Escape key
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && popup.classList.contains('popup-modal--active')) {
        handleClose();
      }
    });
  }

  function setupCopyHandler(popup) {
    const copyBtn = popup.querySelector('.popup-modal__copy-btn');
    const successMsg = popup.querySelector('.popup-modal__success-msg');

    if (!copyBtn) return;

    copyBtn.addEventListener('click', function() {
      const code = this.dataset.code || this.closest('.popup-modal__discount-code').querySelector('.field__input').value;

      navigator.clipboard.writeText(code).then(() => {
        if (successMsg) {
          successMsg.classList.add('show');
          setTimeout(() => {
            successMsg.classList.remove('show');
          }, 3000);
        }
      }).catch(() => {
        // Fallback for older browsers
        const input = popup.querySelector('.popup-modal__discount-code .field__input');
        if (input) {
          input.select();
          document.execCommand('copy');
          if (successMsg) {
            successMsg.classList.add('show');
            setTimeout(() => {
              successMsg.classList.remove('show');
            }, 3000);
          }
        }
      });
    });
  }

  function startTimer(popup, durationMinutes) {
    const timerMinutes = popup.querySelector('.popup-modal__timer__minutes');
    const timerSeconds = popup.querySelector('.popup-modal__timer__seconds');

    if (!timerMinutes || !timerSeconds) return;

    let totalSeconds = Math.floor(durationMinutes * 60);

    function updateDisplay() {
      const mins = Math.floor(totalSeconds / 60);
      const secs = totalSeconds % 60;
      timerMinutes.textContent = mins.toString().padStart(2, '0');
      timerSeconds.textContent = secs.toString().padStart(2, '0');
    }

    updateDisplay();

    const interval = setInterval(() => {
      totalSeconds--;

      if (totalSeconds <= 0) {
        clearInterval(interval);
        totalSeconds = 0;
      }

      updateDisplay();
    }, 1000);
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initPromoPopup);
  } else {
    initPromoPopup();
  }
})();
